import React from 'react';
import arePropsEqual from "react-fast-compare";
import { useTranslation } from "react-i18next";
import {Box, Button, Typography} from "@mui/material";

//components
import { useStyles } from "./styles";


interface IRemove {
    data: any;
    closeModal: (state:boolean) => void;
    removeClick: () => void;
}

const RemovePayment = (props: IRemove) => {
    const {
        data,
        closeModal,
        removeClick,
    } = props;

    const {t} = useTranslation();
    const styles = useStyles();

    return (
        <div>
            <Typography sx={{ mb: 2 }} variant="h6">{t("admin.reports.detailed_fin_report.payouts.remove_title").replace('{amount}', data.amount)}</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">{t("admin.reports.detailed_fin_report.payouts.remove_text")}</Typography>
            <div className={styles.btn__wrapper}>
                <Box className={styles.row_left}>
                    <Button
                      onClick={removeClick}
                      variant="contained"
                      color="secondary"
                      className={styles.btn_remove}
                    >{t("common.buttons.delete")}</Button>
                </Box>
                <Box className={styles.row_right}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      className={styles.btn}
                      onClick={() => closeModal(false)}
                    >{t("common.buttons.cancel")}</Button>
                </Box>
            </div>
        </div>
    )
}

export default React.memo(RemovePayment, arePropsEqual);
